<p-checkbox 
[(ngModel)]="checked"
 [binary]="true"
 [label]="checkboxLabel"
 [disabled]="disabled"
 (ngModelChange)="checkedChange.emit($event)"
 style="font-weight: normal;font-size: smaller;font-family: 'Scania Sans Condensed';"
 >
</p-checkbox>

